const TURNSTILE_SCRIPT_ID = 'cf-turnstile-script'
const TURNSTILE_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA'

let turnstileScriptPromise

const isProductionMode = process.env.VUE_APP_PROD_MODE === 'true'

export const getTurnstileSiteKey = () => {
  if (process.env.VUE_APP_TURNSTILE_SITE_KEY) {
    return process.env.VUE_APP_TURNSTILE_SITE_KEY
  }

  return isProductionMode ? '' : TURNSTILE_TEST_SITE_KEY
}

export const loadTurnstileScript = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Turnstile is only available in the browser'))
  }

  if (window.turnstile) {
    return Promise.resolve(window.turnstile)
  }

  if (turnstileScriptPromise) {
    return turnstileScriptPromise
  }

  turnstileScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(TURNSTILE_SCRIPT_ID)

    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.turnstile))
      existingScript.addEventListener('error', () => reject(new Error('Failed to load Turnstile script')))
      return
    }

    const script = document.createElement('script')
    script.id = TURNSTILE_SCRIPT_ID
    script.src = TURNSTILE_SCRIPT_SRC
    script.async = true
    script.defer = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = () => reject(new Error('Failed to load Turnstile script'))
    document.head.appendChild(script)
  })

  return turnstileScriptPromise
}

export const renderTurnstile = async (container, options = {}) => {
  const turnstile = await loadTurnstileScript()

  if (!container) {
    throw new Error('Turnstile container is missing')
  }

  container.innerHTML = ''

  return turnstile.render(container, {
    theme: 'light',
    ...options
  })
}

export const resetTurnstile = (widgetId) => {
  if (typeof window !== 'undefined' && window.turnstile && widgetId !== null) {
    window.turnstile.reset(widgetId)
  }
}

export const removeTurnstile = (widgetId) => {
  if (typeof window !== 'undefined' && window.turnstile && widgetId !== null) {
    window.turnstile.remove(widgetId)
  }
}
